import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "modal-header border-0" }
const _hoisted_3 = { class: "modal-footer border-0" }

import { Modal } from "bootstrap";
import { onMounted, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    isVisible: { type: Boolean },
    large: { type: Boolean }
  },
  emits: ["hide-modal"],
  setup(__props: any, { emit }) {

const props = __props as {
  isVisible: boolean;
  large?: boolean;
}

const modalElement = ref<HTMLInputElement | null>(null);
let modal: Modal | null = null;





onMounted(() => {
  if (modalElement.value) {
    modal = new Modal(modalElement.value);
  }
  modalElement.value?.addEventListener("hide.bs.modal", () => {
    emit("hide-modal");
  });
});

watch(
  () => props.isVisible,
  (visible: boolean) => {
    if (visible) {
      modal?.show();
    } else {
      modal?.hide();
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    ref_key: "modalElement",
    ref: modalElement,
    tabindex: "-1",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-dialog modal-dialog-centered", { 'modal-lg': __props.large }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "header")
        ]),
        _renderSlot(_ctx.$slots, "body"),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "footer")
        ])
      ])
    ], 2)
  ], 512))
}
}

})